import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { Button } from '@gem/ui-kit';

import { LogoIcon } from 'APP/unauthorized/Pages/Components/LogoIcon/LogoIcon';

import { ISetView } from '../CallInvitation.types';
import { useJoinBlockPresenter } from './JoinBlock.presenter';
import styles from './JoinBlock.styles.m.css';

interface IJoinBlockProps {
  setView: ISetView;
}

export const JoinBlock: FC<IJoinBlockProps> = observer(({ setView }) => {
  const { t } = useTranslation();
  const presenter = useJoinBlockPresenter(setView);

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <LogoIcon
          className={classNames(styles.logo, { [styles.logoShow]: presenter.isShowLogo })}
        />
        <h1 className={styles.title}>{t('call_invitation')}</h1>
        <p className={styles.subTitle}>{t('call_invitation_window_tips_message')}</p>
      </div>
      <div className={styles.buttons}>
        {presenter.isShowJoinAsUserButton && (
          <Button
            onClick={presenter.onJoinAsUserClick}
            className={styles.signButton}
            size="20"
            theme="primary"
          >
            {t('common_sign_in')}
          </Button>
        )}

        <Button
          onClick={presenter.changeView}
          className={styles.joinGuestButton}
          size="20"
          theme="secondary"
        >
          {t('call_join_as_guest')}
        </Button>
      </div>
    </div>
  );
});
